import React from 'react';
import { Box, Tooltip } from '@mui/material';
import { tokens } from '../../theme/tokens';
import { formatWhen, type StoreSyncRow } from './model';
import { RESULT_COLOR, RESULT_LABEL } from './HealthOverview';

const SLOTS = 14;

/** The last 14 runs of one store, oldest to newest. Colour is never the only cue: each bar has a tooltip. */
export const RunStrip: React.FC<{ row: StoreSyncRow }> = ({ row }) => {
  const bars: Array<{ key: string; height: number; color: string; label: string }> = [];
  const missed = row.status === 'missed';
  const runSlots = SLOTS - (missed ? 1 : 0);
  const runs = row.strip.slice(-runSlots);
  for (let i = 0; i < runSlots - runs.length; i += 1) {
    bars.push({ key: `none-${i}`, height: 4, color: tokens.line.default, label: 'No run' });
  }
  runs.forEach((r, i) =>
    bars.push({
      key: `run-${i}`,
      height: 20,
      color: RESULT_COLOR[r.result],
      label: `${formatWhen(r.at)}: ${RESULT_LABEL[r.result].toLowerCase()}`,
    }),
  );
  if (missed) {
    bars.push({ key: 'missed', height: 8, color: tokens.signal.caution.border, label: 'Scheduled run missed' });
  }
  return (
    <Box sx={{ display: 'flex', alignItems: 'flex-end', gap: '2px', height: 20 }} aria-label="Last 14 runs">
      {bars.map((b) => (
        <Tooltip key={b.key} title={b.label} arrow>
          <Box sx={{ width: 5, height: b.height, borderRadius: '1px', bgcolor: b.color }} />
        </Tooltip>
      ))}
    </Box>
  );
};
